<template>
  <div class="add-fab-menu-wrapper">
    <button class="add-fab-btn" @click="toggleMenu">
      <Plus :stroke-width="1" />
    </button>
    <transition name="fade">
      <div v-if="showMenu" class="add-fab-menu">
        <button class="add-fab-menu-item" @click="goTo('project')">
          Project toevoegen
        </button>
        <button class="add-fab-menu-item" @click="goTo('deal')">
          Deal toevoegen
        </button>
        <button class="add-fab-menu-item" @click="goTo('task')">
          Taak toevoegen
        </button>
        <button class="add-fab-menu-item" @click="goTo('call')">
          Call toevoegen
        </button>
        <button class="add-fab-menu-item" @click="goTo('appointment')">
          Afspraak toevoegen
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import { Plus } from "lucide-vue-next";

export default {
  name: "AddFabMenu",
  components: { Plus },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    goTo(type) {
      this.showMenu = false;
      if (type === "project") this.$router.push({ path: "/projects/new" });
      else if (type === "deal") this.$router.push({ path: "/deals/nieuw" });
      else if (type === "task") this.$router.push({ path: "/add-task" });
      else if (type === "call") this.$router.push({ path: "/add-call" });
      else if (type === "appointment")
        this.$router.push({ path: "/add-appointment" });
    },
  },
};
</script>

<style scoped>
.add-fab-menu-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.add-fab-btn {
  background: var(--primary_color);
  color: #fff;
  border: none;
  border-radius: 0.5rem;
  width: 44px;
  height: 44px;
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: background 0.2s;
}
.add-fab-btn svg {
  color: #000;
  width: 2rem;
  height: 2rem;
}
.add-fab-menu {
  position: absolute;
  top: 110%;
  right: 0;
  background: var(--surface);
  border-radius: 0.25rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  min-width: 180px;
  z-index: 10;
  padding: 0.5rem 0;
}
.add-fab-menu-item {
  background: none;
  border: none;
  color: var(--text-primary);
  text-align: left;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.15s;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
